import { useState } from "react";
import { GridButton } from "@src/components/Buttons/GridButton";
import { ImportRowCustom } from "@src/components/Forms/Rows/ImportRow/Custom/ImportRowCustom";
import { ImportRowDoordash } from "@src/components/Forms/Rows/ImportRow/Doordash/ImportRowDoordash";
import { ImportRowNetflix } from "@src/components/Forms/Rows/ImportRow/Netflix/ImportRowNetflix";
import { SaveCancelButtons } from "@src/components/Buttons/SaveCancelButtons";
import { useModal } from "@src/utility_functions/customHooks/useModal";

export const ImportRowOptionsButtonsGrid = (props) => {
  const { closeDialog, setModalContent } = useModal();
  const [saveButtonLoading, setSaveButtonLoading] = useState(false);
  const [saveButtonDisabled, setSaveButtonDisabled] = useState(false);
  return (
    <>
      <div className="dialog_grid_items_container">
        <GridButton
          text="Doordash"
          clickHandler={() => {
            setModalContent({
              modalTitle: "Import Doordash Data",
              modalContent: (
                <ImportRowDoordash
                  loggedInUser={props.loggedInUser}
                  saveButtonLoading={saveButtonLoading}
                  setSaveButtonLoading={setSaveButtonLoading}
                />
              ),
              dialogFooterContent: (
                <SaveCancelButtons
                  formID="importDoordashForm"
                  isPending={saveButtonLoading}
                  isDisabled={saveButtonDisabled}
                  cancelClickHandler={() => {
                    closeDialog();
                  }}
                />
              ),
            });
          }}
        >
          <img
            className="_height--1p5rem _margin-bottom--0p75rem"
            src="/images/logos/doordash_logo.svg"
          />
        </GridButton>
        <GridButton
          text="Netflix"
          clickHandler={() => {
            setModalContent({
              modalTitle: "Import Netflix Data",
              modalContent: (
                <ImportRowNetflix
                  loggedInUser={props.loggedInUser}
                  saveButtonLoading={saveButtonLoading}
                  setSaveButtonLoading={setSaveButtonLoading}
                />
              ),
              dialogFooterContent: (
                <SaveCancelButtons
                  formID="importNetflixForm"
                  saveButtonLoading={saveButtonLoading}
                  setSaveButtonLoading={setSaveButtonLoading}
                  saveButtonDisabled={saveButtonDisabled}
                  setSaveButtonDisabled={setSaveButtonDisabled}
                  cancelClickHandler={() => {
                    closeDialog();
                  }}
                />
              ),
            });
          }}
        >
          <img
            className="_height--2rem _margin-bottom--0p5rem"
            src="/images/logos/netflix_logo.svg"
          />
        </GridButton>
        <GridButton
          text="GoogleMaps"
          clickHandler={() => {
            setModalContent({
              modalTitle: "Import Google Maps Data",
              modalContent: "",
            });
          }}
        >
          <img
            className="_height--2rem _margin-bottom--0p5rem"
            src="/images/logos/google_maps_logo.svg"
          />
        </GridButton>
        <GridButton
          text="Import JSON"
          clickHandler={() => {
            setModalContent({
              modalTitle: "Import JSON / CSV",
              modalContent: (
                <>
                  <ImportRowCustom
                    loggedInUser={props.loggedInUser}
                    chartType={props.chartType}
                    chartID={props.chartID}
                    ownerID={props.ownerID}
                    customClass=""
                    saveButtonLoading={saveButtonLoading}
                    setSaveButtonLoading={setSaveButtonLoading}
                  />
                </>
              ),
              dialogFooterContent: (
                <SaveCancelButtons
                  formID="importCustomJSONForm"
                  cancelClickHandler={() => closeDialog()}
                  isPending={saveButtonLoading}
                  setIsPending={setSaveButtonLoading}
                  isDisabled={saveButtonDisabled}
                />
              ),
            });
          }}
        >
          <img
            className="_height--1p75rem _opacity--0p2 _margin-bottom--0p5rem"
            src="/images/icons/code_icon.svg"
          />
        </GridButton>
      </div>
    </>
  );
};
